import React, { forwardRef } from 'react';
import { useLanguage } from './LanguageProvider';
import styles from "./QuestionSubmitButton.module.scss";

const QuestionSubmitButton = ({ loading, questionListButton = false, ...props }, ref) => {
  const language = useLanguage();
  const { caption = language === 'nl' ? '>' : '>' } = props; // XXX use Translation lib, fallback = Next
  return (
    <button
      type="submit"
      id="next"
      className={`${styles.nextButton} button is-primary brand-primary is-medium is-fullwidth${loading ? ' is-loading' : ''}`
      }
      ref={ref}
      {...props}
    >
      {caption}
    </button>
  );
};

export default forwardRef(QuestionSubmitButton);
